import { useState } from "react";
import Navbar from "../../../../common/layout/Navbar";
import { LicenseTypes } from "../../../../../utils/Enum.types";
import List from "./List";
import Table, { TicketTablePageFor } from "./Table";
import { AppProvider } from "../../maps/context/context";
import { TicketsQueryType } from "../../../../../queries/types";
import useUrlParams from "../../../../../customHooks/useUrlParams";
export interface TicketListProps {
  queryType: TicketsQueryType;
}
const TicketWiseIndex = ({ queryType }: TicketListProps) => {
  const { customer_id, company_id } = useUrlParams();
  const [modal, setModal] = useState(false);
  return (
    <AppProvider>
      {customer_id && company_id ? (
        <Navbar NavType={LicenseTypes.COMPANY} />
      ) : (
        <Navbar NavType={LicenseTypes.DASHBOARD} />
      )}

      <div className="asset-reports">
        <div className="asset-reports__left">
          <List queryType={queryType} />
        </div>
        <div className="asset-reports__right">
          <Table
            queryType={queryType}
            pageFor={TicketTablePageFor.REPORTS}
            setModalFlag={setModal}
          />
        </div>
      </div>
    </AppProvider>
  );
};

export default TicketWiseIndex;
